import { useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import { Modals, useModal } from "../../contexts/ModalContext";
import { useAuthContext } from "../../contexts/AuthContext";
import { isViewAsActive } from "../../utils/auth";
import { ModalContainer } from "./Modal.styles";
import { ModalContent } from "./ModalContent";
import { Variants } from "./Modal.variants";

export const GlobalGenderModal = () => {
  const { user } = useAuthContext();
  const { modalState, openModal, closeModal } = useModal();
  const theme = useTheme();
  const variantStylesFn = Variants(theme);

  useEffect(() => {
    if (
      user &&
      !user.isVirtual &&
      !isViewAsActive() &&
      user.gender == null &&
      modalState === Modals.None
    ) {
      openModal(Modals.SetGender);
    }
  }, [user, modalState, openModal]);

  if (modalState !== Modals.SetGender) {
    return null;
  }

  return (
    <ModalContainer
      data-cy="modal-container"
      PaperProps={{ elevation: 0 }}
      open={true}
      sx={{ ...variantStylesFn["SetGender"] }}
    >
      <ModalContent.SetGender closeModal={closeModal} />
    </ModalContainer>
  );
};

GlobalGenderModal.displayName = "GlobalGenderModal";
